import {
  DashboardOutlined,
  RocketOutlined,
  BranchesOutlined,
  LockOutlined,
  MenuOutlined,
  CrownOutlined,
  FileProtectOutlined,
  ClusterOutlined,
  TeamOutlined,
  ThunderboltOutlined,
  DeploymentUnitOutlined,
  BankOutlined,
  PieChartOutlined,
  CompassOutlined,
  PullRequestOutlined,
  PlayCircleOutlined,
  UserSwitchOutlined
} from '@ant-design/icons';

export const getIconComponent = (iconName) => {
  switch (iconName) {
    case 'Dashboard':
      return <DashboardOutlined />;
    case 'Cto':
      return <BankOutlined />;
    case 'Workstream':
      return <CrownOutlined />;
    case 'Subworkstream':
      return <ClusterOutlined />;
    case 'Sector':
      return <PieChartOutlined />;
    case 'Subsector':
      return <DeploymentUnitOutlined />;
    case 'Strategy':
      return <CompassOutlined />;
    case 'Request':
      return <PullRequestOutlined />;
    case 'Workstreamaction':
      return <PlayCircleOutlined />;
    case 'Delegate':
      return <UserSwitchOutlined />;
    // case 'Division':
    //   return <DeploymentUnitOutlined  />;
    case 'Initiative':
      return <RocketOutlined />;
    // case 'Impact':
    //   return <ThunderboltOutlined />;
    // case 'Category':
    //   return <BranchesOutlined />;
    case 'User':
      return <TeamOutlined />;
    case 'Role':
      return <LockOutlined />;
    // case 'Report':
    //   return <FileProtectOutlined />;

    default:
      return <MenuOutlined />;
  }
};
